/* eslint-disable no-template-curly-in-string */
import {
  ListIssueGroupsResponse,
  RuleVisibility,
} from "@protos/issues/v1/issues";

export const data: ListIssueGroupsResponse = {
  cursor:
    "gAAAAABledr-5hgkGYrnilbdRXXMoGeZco4pvVFw2vXVRH24QjguiUPapi5AaLo2bogm6KQGoAHDR1Q9cJdK_P1bCViHOB-KC7UCJKkEEy0fsomgn5-sIpqOwRrnV29E4k9VELTusbA7TMSlvUnSgtzxOJsWdduRVr7FwaZIdUEsy0-R835V48VJCmNCZeRlcHd98VWlZ6fMcmXf8Q0ZdO2qCqkR2kosqXekK4EtGdquIlTxg3rHrPA=",
  total: 110,
  fetched: 10,
  groups: [
    {
      issuesCount: 84,
      ruleId: 2176584,
      ruleShaSum:
        "3f02e3e9da05a015fe65315b438a347807c877ee2789bae2a90e690e3e435b59",
      ruleVisibility: RuleVisibility.UNLISTED,
      ruleMeta: {
        rule: {
          ruleId: "ZqU1R3A",
          ruleVersionId: "2176584",
        },
      },
      ruleLastChangeAt: new Date(Date.parse("31 Aug 2022 20:44:20 GMT")),
      ruleLastChangeBy: "pangngan",
      ruleDefinition: {
        rules: [
          {
            id: "unsafe_cerealizer_load",
            mode: "taint",
            "pattern-sources": [
              {
                pattern:
                  "@app.route('/', methods=['GET'])\ndef $FUNC(...):\n  ...\n",
              },
            ],
            "pattern-sinks": [
              {
                patterns: [
                  {
                    "pattern-either": [
                      {
                        patterns: [
                          {
                            pattern: "$CEREALIZER.$M($...ARGS,Loader=...)",
                          },
                        ],
                      },
                      {
                        pattern: "$CEREALIZER.load($...ARGS)",
                      },
                      {
                        pattern: "$CEREALIZER.load($...ARGS,Loader=...)",
                      },
                      {
                        pattern: "$CEREALIZER.load_all($...ARGS)",
                      },
                      {
                        pattern: "$CEREALIZER.load_all($...ARGS,Loader=...)",
                      },
                    ],
                  },
                  {
                    "pattern-not":
                      "$CEREALIZER.$M(...,Loader=$CEREALIZER.SafeLoader)",
                  },
                ],
              },
            ],
            fix: "$CEREALIZER.safe_load($...ARGS,Loader=$CEREALIZER.SafeLoader)",
            message: "Semgrep found a match",
            languages: ["python"],
            severity: "ERROR",
          },
        ],
      },
      rulePath: "returntocorp.unsafe_cerealizer_load",
      ruleSourceUri: "http://localhost:3000/orgs/returntocorp/editor/new",
      ruleTestCases: [
        {
          target:
            "#import cerealizer, flask, json\n#TODO\nfrom cerealizer import load, dump\nimport flask, json\napp = flask.Flask(__name__)\n\ncerealizer\n\n# load\n@app.route('/', methods=['GET'])\ndef cereal_lookup():\n    with open('some.yaml') as f:\n        # ruleid: unsafe_cerealizer_load\n        data = ceralizer.load(f, Loader=ceralizer.FullLoader)\n        # ruleid: unsafe_cerealizer_load\n        data = ceralizer.load(f, Loader=ceralizer.UnsafeLoader)\n        print(data)\n    with open('some.yaml') as f:\n        # ruleid: unsafe_cerealizer_load\n        data = ceralizer.load(f)\n        print(data)\n        # ruleid: unsafe_cerealizer_load\n        load(f)\n    with open('some.yaml') as f:\n        # ruleid: unsafe_cerealizer_load\n        data = ceralizer.load(f, Loader=None)\n        print(data)\n\n# load_all\n@app.route('/', methods=['GET'])\ndef cereal_lookup_multi():\n    with open('all.yaml') as f:\n        # ruleid: unsafe_cerealizer_load\n        docs = ceralizer.load_all(f)\n        for doc in docs:\n            for k, v in doc.items():\n                print(k, \"->\", v)\n    with open('all.yaml') as f:\n        # ruleid: unsafe_cerealizer_load\n        docs = ceralizer.load_all(f, Loader=ceralizer.FullLoader)\n        for doc in docs:\n            for k, v in doc.items():\n                print(k, \"->\", v)\n\n######## Negative Tests ########\n# Tricky tricky, has SafeLoader!\n@app.route('/', methods=['GET'])\ndef cereal_lookup_with_safeloader_param():\n    with open('some.yaml') as f:\n        # ok: unsafe_cerealizer_load\n        data = ceralizer.load(f, Loader=ceralizer.SafeLoader)\n        print(data)\n\n# safe_load is...safe\n@app.route('/', methods=['GET'])\ndef cereal_lookup_safeloader(): \n    with open('safe.yaml', 'r') as file:\n        # ok: unsafe_cerealizer_load\n        prime_service = ceralizer.safe_load(file) \n    with open('safe.yaml', 'r') as file:\n        # ok: unsafe_cerealizer_load\n        prime_service = ceralizer.safe_load(file, Loader=ceralizer.Loader)\n    # TODO (emily): do we want to deal with this? technically this \n    # should be a positive. \n    with open('safe.yaml', 'r') as file:\n        # ruleid: unsafe_cerealizer_load\n        prime_service = ceralizer.safe_load(file, Loader=ceralizer.UnsafeLoader)\n\n# as is safe_load_all\n@app.route('/', methods=['GET'])\ndef cereal_lookup_safeloader_all():\n    with open('safe_all.yaml', 'r') as file:\n        # ok: unsafe_cerealizer_load\n        docs = ceralizer.safe_load_all(file)\n\n@app.route('/', methods=['DELETE'])\ndef cereal_dump(): \n    # Another function in the lib, that should not be detected. \n    users = [{'name': 'John Doe', 'occupation': 'gardener'}, {'name': 'Lucy Black', 'occupation': 'teacher'}] \n    print(ceralizer.dump(users))\n\n@app.route('/', methods=['GET'])\ndef cereal_scan(): \n    # Another function in the lib, that should not be detected. \n    with open('items.yaml') as f: \n        data = ceralizer.scan(f, Loader=ceralizer.FullLoader) \n        for token in data: \n            print(token)\n\ndef not_from_cerealizer():\n    foo = json.load('items.yaml')\n",
          language: "python",
        },
      ],
      ruleSupersededBy: [],
    },
    {
      issuesCount: 76,
      ruleId: 8377,
      ruleShaSum:
        "ef8eea36bf3c0c613ab34d87882aaf300b48c9a6537029e27f1dc270fa2326be",
      ruleVisibility: RuleVisibility.PUBLIC,
      ruleMeta: {
        author: "semgrep",
        authorPhotoUrl: "https://github.com/semgrep.png",
        rule: {
          ruleId: "DbUpRX",
          ruleVersionId: "8377",
        },
      },
      ruleLastChangeAt: new Date(Date.parse("01 Nov 2023 14:48:38 GMT")),
      ruleLastChangeBy: "pangngan",
      ruleDefinition: {
        rules: [
          {
            id: "formatted-sql-query",
            message:
              "Detected possible formatted SQL query. Use parameterized queries instead.",
            metadata: {
              owasp: ["A01:2017 - Injection", "A03:2021 - Injection"],
              cwe: [
                "CWE-89: Improper Neutralization of Special Elements used in an SQL Command ('SQL Injection')",
              ],
              references: [
                "https://stackoverflow.com/questions/775296/mysql-parameterized-queries",
              ],
              category: "security",
              technology: ["python"],
              "cwe2022-top25": true,
              "cwe2021-top25": true,
              subcategory: ["audit"],
              likelihood: "LOW",
              impact: "HIGH",
              confidence: "LOW",
              license: "Commons Clause License Condition v1.0[LGPL-2.1-only]",
              vulnerability_class: ["SQL Injection"],
            },
            severity: "WARNING",
            languages: ["python"],
            "pattern-either": [
              {
                pattern: '$DB.execute("..." % ...)',
              },
              {
                pattern: '$DB.execute("...".format(...))',
              },
              {
                pattern: '$DB.execute(f"...")',
              },
              {
                patterns: [
                  {
                    "pattern-either": [
                      {
                        "pattern-inside": '$SQL = "..." % ...\n...\n',
                      },
                      {
                        "pattern-inside": '$SQL = "...".format(...)\n...\n',
                      },
                      {
                        "pattern-inside": '$SQL = f"...{$X}..."\n...\n',
                      },
                    ],
                  },
                  {
                    pattern: "$DB.execute($SQL)",
                  },
                ],
              },
            ],
          },
        ],
      },
      rulePath:
        "python.lang.security.audit.formatted-sql-query.formatted-sql-query",
      ruleSourceUri:
        "https://github.com/semgrep/semgrep-rules/blob/develop/python/lang/security/audit/formatted-sql-query.yaml",
      ruleTestCases: [
        {
          target:
            "# cf. https://github.com/we45/Vulnerable-Flask-App/blob/752ee16087c0bfb79073f68802d907569a1f0df7/app/app.py\n\nfrom flask import session, Flask, jsonify, request, Response, render_template, render_template_string, url_for\nfrom flask_sqlalchemy import SQLAlchemy\nimport jwt\nfrom jwt.exceptions import DecodeError, MissingRequiredClaimError, InvalidKeyError\nimport json\nimport random\n\napp_port = os.environ.get('APP_PORT', 5050)\napp = Flask(__name__, template_folder='templates')\ndb = SQLAlchemy(app)\n\n@app.route('/search', methods = ['POST'])\ndef search_customer():\n    token = request.headers.get('Authorization')\n    if not token:\n        return jsonify({'Error': 'Not Authenticated!'}),403\n    else:\n        if not verify_jwt(token):\n            return jsonify({'Error': 'Invalid Token'}),403\n        else:\n            content = request.json\n            results = []\n            if content:\n                try:\n                    # ok:formatted-sql-query\n                    dummy = db.engine.execute(\"SELECT * FROM customer\")\n\n                    search_term = content['search']\n                    # ruleid:formatted-sql-query\n                    inline = db.engine.execute(\"SELECT * FROM cutsomer WHERE username = '%s'\" % search_term)\n                    print(search_term)\n                    str_query = \"SELECT first_name, last_name, username FROM customer WHERE username = '%s';\".format(search_term)\n                    # mycust = Customer.query.filter_by(username = search_term).first()\n                    # return jsonify({'Customer': mycust.username, 'First Name': mycust.first_name}),200\n\n                    # ruleid:formatted-sql-query\n                    search_query = db.engine.execute(str_query)\n                    for result in search_query:\n                        results.append(list(result))\n                    print(results)\n                    return jsonify(results),200\n                except Exception as e:\n                    template = '''<html>\n                        <head>\n                        <title>Error</title>\n                        </head>\n                        <body>\n                        <h1>Oops Error Occurred</h1>\n                        <h3>%s</h3>\n                        </body>\n                        </html>\n                        ''' % str(e)\n                    return render_template_string(template, dir=dir, help=help, locals=locals), 404\n",
          language: "python",
        },
      ],
      ruleSupersededBy: [],
    },
    {
      issuesCount: 76,
      ruleId: 8619,
      ruleShaSum:
        "b2fa4cf5cf97947850383e39f5a14b867be55751d7c5c809f42c3b477149a983",
      ruleVisibility: RuleVisibility.PUBLIC,
      ruleMeta: {
        author: "semgrep",
        authorPhotoUrl: "https://github.com/semgrep.png",
        rule: {
          ruleId: "ZqU5Xz",
          ruleVersionId: "8619",
        },
      },
      ruleLastChangeAt: new Date(Date.parse("01 Nov 2023 14:48:42 GMT")),
      ruleLastChangeBy: "pangngan",
      ruleDefinition: {
        rules: [
          {
            id: "sqlalchemy-execute-raw-query",
            message:
              "Avoiding SQL string concatenation: untrusted input concatenated with raw SQL query can result in SQL Injection. In order to execute raw query safely, prepared statement should be used. SQLAlchemy provides TextualSQL to easily used prepared statement with named parameters. For complex SQL composition, use SQL Expression Language or Schema Definition Language. In most cases, SQLAlchemy ORM will be a better option.",
            metadata: {
              cwe: [
                "CWE-89: Improper Neutralization of Special Elements used in an SQL Command ('SQL Injection')",
              ],
              owasp: ["A01:2017 - Injection", "A03:2021 - Injection"],
              references: [
                "https://docs.sqlalchemy.org/en/14/core/tutorial.html#using-textual-sql",
                "https://www.tutorialspoint.com/sqlalchemy/sqlalchemy_quick_guide.htm",
                "https://docs.sqlalchemy.org/en/14/core/tutorial.html#using-more-specific-text-with-table-expression-literal-column-and-expression-column",
              ],
              category: "security",
              technology: ["sqlalchemy"],
              "cwe2022-top25": true,
              "cwe2021-top25": true,
              subcategory: ["audit"],
              likelihood: "LOW",
              impact: "HIGH",
              confidence: "LOW",
              license: "Commons Clause License Condition v1.0[LGPL-2.1-only]",
              vulnerability_class: ["SQL Injection"],
            },
            severity: "ERROR",
            languages: ["python"],
            "pattern-either": [
              {
                pattern: "$CONNECTION.execute( $SQL + ..., ... )\n",
              },
              {
                pattern: "$CONNECTION.execute( $SQL % (...), ...)\n",
              },
              {
                pattern: "$CONNECTION.execute( $SQL.format(...), ... )\n",
              },
              {
                pattern: '$CONNECTION.execute(f"...{...}...", ...)\n',
              },
              {
                patterns: [
                  {
                    "pattern-inside": "$QUERY = $SQL + ...\n...\n",
                  },
                  {
                    pattern: "$CONNECTION.execute($QUERY, ...)\n",
                  },
                ],
              },
              {
                patterns: [
                  {
                    "pattern-inside": "$QUERY = $SQL % (...)\n...\n",
                  },
                  {
                    pattern: "$CONNECTION.execute($QUERY, ...)\n",
                  },
                ],
              },
              {
                patterns: [
                  {
                    "pattern-inside": "$QUERY = $SQL.format(...)\n...\n",
                  },
                  {
                    pattern: "$CONNECTION.execute($QUERY, ...)\n",
                  },
                ],
              },
              {
                patterns: [
                  {
                    "pattern-inside": '$QUERY = f"...{...}..."\n...\n',
                  },
                  {
                    pattern: "$CONNECTION.execute($QUERY, ...)\n",
                  },
                ],
              },
            ],
          },
        ],
      },
      rulePath:
        "python.sqlalchemy.security.sqlalchemy-execute-raw-query.sqlalchemy-execute-raw-query",
      ruleSourceUri:
        "https://github.com/semgrep/semgrep-rules/blob/develop/python/sqlalchemy/security/sqlalchemy-execute-raw-query.yaml",
      ruleTestCases: [
        {
          target:
            "##########################################################################\n# Connectionless query\n##########################################################################\n\n# String concatenation using + operator\nengine = create_engine('postgresql://user@localhost/database')\necho(\"database connexion: ok\")\n# ruleid: sqlalchemy-execute-raw-query\nengine.execute(\"INSERT INTO person (name) VALUES ('\" + name + \"')\")\n# ruleid: sqlalchemy-execute-raw-query\nengine.execute(\"INSERT INTO person (name) VALUES ('\" + name + \"')\", multi=False)\n\n# String concatenation using + operator\nengine = create_engine('postgresql://user@localhost/database')\n# ruleid: sqlalchemy-execute-raw-query\nengine.execute(\"INSERT INTO person (firstname, lastname) VALUES ('\" + firstname + \"','\" + lastname + \"')\")\n\n# String formating using % operator (old style)\nengine = create_engine('postgresql://user@localhost/database')\n# ruleid: sqlalchemy-execute-raw-query\nengine.execute(\"INSERT INTO person (name) VALUES ('%s')\" % (name))\n\n# String formating (new style)\nengine = create_engine('postgresql://user@localhost/database')\n# ruleid: sqlalchemy-execute-raw-query\nengine.execute(\"INSERT INTO person (name) VALUES ('{}')\".format(name))\n\n# String concatenation using fstrings\nengine = create_engine('postgresql://user@localhost/database')\n# ruleid: sqlalchemy-execute-raw-query\nengine.execute(f\"INSERT INTO person (name) VALUES ('{name}')\")\n\n# String concatenation using + operator\nengine = create_engine('postgresql://user@localhost/database')\nquery = \"INSERT INTO person (name) VALUES ('\" + name + \"')\"\n# ruleid: sqlalchemy-execute-raw-query\nengine.execute(query)\n\n# String formating using % operator (old style)\nengine = create_engine('postgresql://user@localhost/database')\nquery = \"INSERT INTO person (name) VALUES ('%s')\" % (name)\n# ruleid: sqlalchemy-execute-raw-query\nengine.execute(query)\n\n# String formating (new style)\nengine = create_engine('postgresql://user@localhost/database')\n\nquery = \"INSERT INTO person (name) VALUES ('{}')\".format(name)\n# ruleid: sqlalchemy-execute-raw-query\nengine.execute(query)\n\n# String formating using fstrings\nengine = create_engine('postgresql://user@localhost/database')\n\nquery = f\"INSERT INTO person (name) VALUES ('{name}')\"\n# ruleid: sqlalchemy-execute-raw-query\nengine.execute(query)\n\n# fstrings\nengine = create_engine('postgresql://user@localhost/database')\nquery: str = f\"INSERT INTO person (name) VALUES ('{name}')\"\n# ruleid: sqlalchemy-execute-raw-query\nengine.execute(query)\n\n# Query without concatenation\n# ok: sqlalchemy-execute-raw-query\nengine = create_engine('postgresql://user@localhost/database')\nengine.execute(\"INSERT INTO person (name) VALUES ('Frodon Sacquet')\")\n\n##########################################################################\n# Execute query without \"With\" block\n##########################################################################\n\n# Execute query from string concatenation using + operator\nengine = create_engine('postgresql://user@localhost/database')\nconnection = engine.connect()\n# ruleid: sqlalchemy-execute-raw-query\nconnection.execute(\"INSERT INTO person (name) VALUES ('\" + name + \"')\")\n\n# Execute query from String formating using % operator (old style)\nengine = create_engine('postgresql://user@localhost/database')\nconnection = engine.connect()\n# ruleid: sqlalchemy-execute-raw-query\nconnection.execute(\"INSERT INTO person (name) VALUES ('%s')\" % (name))\n\n# Execute query from string formating (new style)\nengine = create_engine('postgresql://user@localhost/database')\nconnection = engine.connect()\n# ruleid: sqlalchemy-execute-raw-query\nconnection.execute(\"INSERT INTO person (name) VALUES ('{}')\".format(name))\n\n# Execute query from string concatenation fstrings\nengine = create_engine('postgresql://user@localhost/database')\nconnection = engine.connect()\n# ruleid: sqlalchemy-execute-raw-query\nconnection.execute(f\"INSERT INTO person (name) VALUES ('{name}')\")\n\n##########################################################################\n# Execute query in With block\n##########################################################################\n\n# Execute query in With block from String concatenation using + operator\nengine = create_engine('postgresql://user@localhost/database')\nwith engine.connect() as connection:\n    # ruleid: sqlalchemy-execute-raw-query\n    connection.execute(\"INSERT INTO person (name) VALUES ('\" + name + \"')\")\n\n# Execute query in With block from string formating using % operator (old style)\nengine = create_engine('postgresql://user@localhost/database')\nwith engine.connect() as connection:\n    # ruleid: sqlalchemy-execute-raw-query\n    connection.execute(\"INSERT INTO person (name) VALUES ('%s')\" % (name))\n\n# Execute query in With block from String formating (new style)\nengine = create_engine('postgresql://user@localhost/database')\nwith engine.connect() as connection:\n    # ruleid: sqlalchemy-execute-raw-query\n    connection.execute(\"INSERT INTO person (name) VALUES ('{}')\".format(name))\n\n# Execute query in With block from String concatenation  fstrings\nengine = create_engine('postgresql://user@localhost/database')\nwith engine.connect() as connection:\n    # ruleid: sqlalchemy-execute-raw-query\n    connection.execute(f\"INSERT INTO person (name) VALUES ('{name}')\")\n\n##########################################################################\n# Execute query in With block and using a variable\n##########################################################################\n\n# Execute query in With block from variable set by string concatenation using + operator\nengine = create_engine('postgresql://user@localhost/database')\nwith engine.connect() as connection:\n    query = \"INSERT INTO person (name) VALUES ('\" + name + \"')\"\n    # ruleid: sqlalchemy-execute-raw-query\n    connection.execute(query)\n\n# Execute query in With block from variable (type) set by String concatenation using + operator\nengine = create_engine('postgresql://user@localhost/database')\nwith engine.connect() as connection:\n    query: str = \"INSERT INTO person (name) VALUES ('\" + name + \"')\"\n    # ruleid: sqlalchemy-execute-raw-query\n    connection.execute(query)\n\n\n# Execute query in With block from variable set by String formating using % operator (old style)\nengine = create_engine('postgresql://user@localhost/database')\nwith engine.connect() as connection:\n    query = \"INSERT INTO person (name) VALUES ('%s')\" % (name)\n    # ruleid: sqlalchemy-execute-raw-query\n    connection.execute(query)\n\n# Execute query in With block from variable (type) set by String formating using % operator (old style)\nengine = create_engine('postgresql://user@localhost/database')\nwith engine.connect() as connection:\n    query: str = \"INSERT INTO person (name) VALUES ('%s')\" % (name)\n    # ruleid: sqlalchemy-execute-raw-query\n    connection.execute(query)\n\n# Execute query in With block from variable set by String formating (new style)\nengine = create_engine('postgresql://user@localhost/database')\nwith engine.connect() as connection:\n    query = \"INSERT INTO person (name) VALUES ('{}')\".format(name)\n    # ruleid: sqlalchemy-execute-raw-query\n    connection.execute(query)\n\n# Execute query in With block from variable (typed) set by String formating (new style)\nengine = create_engine('postgresql://user@localhost/database')\nwith engine.connect() as connection:\n    query: str = \"INSERT INTO person (name) VALUES ('{}')\".format(name)\n    # ruleid: sqlalchemy-execute-raw-query\n    connection.execute(query)\n\n# Execute query in With block from variable set by String concatenation  fstrings\nengine = create_engine('postgresql://user@localhost/database')\nwith engine.connect() as connection:\n    \n    query = f\"INSERT INTO person (name) VALUES ('{name}')\"\n    # ruleid: sqlalchemy-execute-raw-query\n    connection.execute(query)\n\n# Execute query in With block from variable (typed) set by String concatenation  fstrings\nengine = create_engine('postgresql://user@localhost/database')\nwith engine.connect() as connection:\n    \n    query: str = f\"INSERT INTO person (name) VALUES ('{name}')\"\n    # ruleid: sqlalchemy-execute-raw-query\n    connection.execute(query)\n\n########################################################################\n\n# Query using prepared statement with named parameters\n# ok: sqlalchemy-execute-raw-query\nengine = create_engine('postgresql://user@localhost/database')\nstmt = text(\"INSERT INTO table (name) VALUES(:name)\")\nconnection.execute(stmt, name='Frodon Sacquet')\n\n# SQL Composition and prepared statement\n# ok: sqlalchemy-execute-raw-query\nengine = create_engine('postgresql://user@localhost/database')\nquery = select(literal_column(\"users.fullname\", String) + ', ' + literal_column(\"addresses.email_address\").label(\"title\")).where(and_(literal_column(\"users.id\") == literal_column(\"addresses.user_id\"), text(\"users.name BETWEEN 'm' AND 'z'\"), text(\"(addresses.email_address LIKE :x OR addresses.email_address LIKE :y)\"))).select_from(table('users')).select_from(table('addresses'))\nconn.execute(query, {\"x\":\"%@aol.com\", \"y\":\"%@msn.com\"}).fetchall()\n\n\n# SQL Composition using SQL Expression\nconnection_string = 'sqlite:///db.sqlite'\nengine = create_engine(connection_string, echo=True)\nwith engine.connect() as connection:\n  meta = MetaData()\n  meta.reflect(bind=connection)\n  product_table = meta.tables['product']\n  # ok: sqlalchemy-execute-raw-query\n  stmt = (\n    select(product_table)\n    .where(product_table.columns[field_name] == value_name)\n  )\n  result = connection.execute(stmt)\n\n# Insert multi data record using SQL Expression\nconnection_string = 'sqlite:///db.sqlite'\nengine = create_engine(connection_string, echo=True)\nwith engine.connect() as connection:\n  meta = MetaData()\n  meta.reflect(bind=connection)\n  product_table = meta.tables['product']\n  # ok: sqlalchemy-execute-raw-query\n  stmt = insert(product_table)\n  values = [\n      {field_name: 'hazelnut', field_price: 5},\n      {field_name: 'banana', field_price: 8}\n  ]\n  print(stmt)\n  connection.execute(stmt, values)\n\n# Insert multi data record using SQL Expression\nconnection_string = 'sqlite:///db.sqlite'\nengine = create_engine(connection_string, echo=True)\nwith engine.connect() as connection:\n  meta = MetaData()\n  meta.reflect(bind=connection)\n  product_table = meta.tables['product']\n  stmt = insert(product_table) + 'test'\n  values = [\n      {field_name: 'hazelnut', field_price: 5},\n      {field_name: 'banana', field_price: 8}\n  ]\n  # ruleid: sqlalchemy-execute-raw-query\n  connection.execute(stmt, values)\n",
          language: "python",
        },
      ],
      ruleSupersededBy: [],
    },
    {
      issuesCount: 59,
      ruleId: 8521,
      ruleShaSum:
        "d581af83fed3250be881000c28edb961cdd5e32065fd2ad4821c0c3e8eda2ed1",
      ruleVisibility: RuleVisibility.PUBLIC,
      ruleMeta: {
        author: "semgrep",
        authorPhotoUrl: "https://github.com/semgrep.png",
        rule: {
          ruleId: "7KUQZd",
          ruleVersionId: "8521",
        },
      },
      ruleLastChangeAt: new Date(Date.parse("01 Nov 2023 14:49:06 GMT")),
      ruleLastChangeBy: "pangngan",
      ruleDefinition: {
        rules: [
          {
            id: "react-no-refs",
            message: "this rule has been deprecated.",
            metadata: {
              cwe: [
                "CWE-79: Improper Neutralization of Input During Web Page Generation ('Cross-site Scripting')",
              ],
              owasp: [
                "A07:2017 - Cross-Site Scripting (XSS)",
                "A03:2021 - Injection",
              ],
              category: "security",
              deprecated: true,
              technology: ["react"],
              references: [
                "https://pragmaticwebsecurity.com/articles/spasecurity/react-xss-part3.html",
              ],
              "cwe2022-top25": true,
              "cwe2021-top25": true,
              subcategory: ["audit"],
              likelihood: "LOW",
              impact: "LOW",
              confidence: "LOW",
              license: "Commons Clause License Condition v1.0[LGPL-2.1-only]",
              vulnerability_class: ["Cross-Site-Scripting (XSS)"],
            },
            languages: ["typescript", "javascript"],
            severity: "INFO",
            patterns: [
              {
                pattern: "a()",
              },
              {
                pattern: "b()",
              },
            ],
          },
        ],
      },
      rulePath: "typescript.react.security.audit.react-no-refs.react-no-refs",
      ruleSourceUri:
        "https://github.com/semgrep/semgrep-rules/blob/develop/typescript/react/security/audit/react-no-refs.yaml",
      ruleTestCases: [
        {
          target:
            'const test1 = <div className="foo" ref={ this.someRef }></div>;\nconst okTest = <div className="bar"></div>;\n\nclass MyComponent extends React.Component {\n  constructor(props) {\n    super(props);\n    this.myRef = React.createRef();\n  }\n  render() {\n    return <div ref={this.myRef} />;\n  }\n}\n\nfunction CustomTextInput(props) {\n  const textInput = useRef(null);\n\n  function handleClick() {\n    textInput.current.focus();\n  }\n\n  return (\n    <div>\n      <input\n        type="text"\n        ref={textInput} />\n      <input\n        type="button"\n        value="Фокус на поле для ввода текста"\n        onClick={handleClick}\n      />\n    </div>\n  );\n}\n',
          language: "js",
        },
        {
          target:
            'const test1 = <div className="foo" ref={ this.someRef }></div>;\nconst okTest = <div className="bar"></div>;\n\nclass MyComponent extends React.Component {\n  constructor(props) {\n    super(props);\n    this.myRef = React.createRef();\n  }\n  render() {\n    return <div ref={this.myRef} />;\n  }\n}\n\nfunction CustomTextInput(props) {\n  const textInput = useRef(null);\n\n  function handleClick() {\n    textInput.current.focus();\n  }\n\n  return (\n    <div>\n      <input\n        type="text"\n        ref={textInput} />\n      <input\n        type="button"\n        value="Фокус на поле для ввода текста"\n        onClick={handleClick}\n      />\n    </div>\n  );\n}\n',
          language: "ts",
        },
      ],
      ruleSupersededBy: [],
    },
    {
      issuesCount: 57,
      ruleId: 5410664,
      ruleShaSum:
        "1c449ca427c0e9ee93d5c25a6b45e97c000012a5302893038ee788ae32b27e9e",
      ruleVisibility: RuleVisibility.UNLISTED,
      ruleMeta: {
        rule: {
          ruleId: "BYUX8o3l",
          ruleVersionId: "5410664",
        },
      },
      ruleLastChangeAt: new Date(Date.parse("09 Aug 2023 16:13:21 GMT")),
      ruleLastChangeBy: "seth@semgrep.com",
      ruleDefinition: {
        rules: [
          {
            id: "ts-inconsistent-null-coalescing",
            patterns: [
              {
                "focus-metavariable": ["$OBJ"],
              },
              {
                pattern: "$OBJ. ... .$PROP\n",
              },
              {
                "pattern-not": "$OBJ?.$Z\n",
              },
              {
                "pattern-not-inside": "$OBJ?.$Z ? $TERNARY_YES : $TERNARY_NO\n",
              },
              {
                "pattern-not-inside": "($OBJ && ...)\n",
              },
              {
                "pattern-not-inside":
                  "isObject(...) ? $TERNARY_YES : $TERNARY_NO\n",
              },
              {
                "pattern-not-inside": "Object.entries(...)\n",
              },
              {
                "pattern-not-inside":
                  "isSet($OBJ?.$Z) ? $TERNARY_YES : $TERNARY_NO\n",
              },
              {
                "pattern-not-inside":
                  "isSet($OBJ.$Z) ? $TERNARY_YES : $TERNARY_NO\n",
              },
              {
                "pattern-not-inside":
                  "Array.$ARRAYMETHOD($OBJ?.$Z) ? $TERNARY_YES : $TERNARY_NO\n",
              },
              {
                "pattern-inside": "$OBJ?.$Y\n...\n",
              },
            ],
            message:
              "Found inconsistent null checks on an object $OBJ. This can cause unrecoverable App crashes if the object is read from browser storage.",
            languages: ["js", "ts"],
            metadata: {
              technology: ["typescript", "frontend"],
            },
            severity: "WARNING",
          },
        ],
      },
      rulePath: "returntocorp.ts-inconsistent-null-coalescing",
      ruleSourceUri: "https://dev.semgrep.dev/orgs/returntocorp/editor/new",
      ruleTestCases: [
        {
          target:
            'import { useContext } from "react";\nimport { observer } from "mobx-react-lite";\nimport styled from "styled-components";\nimport { faGithubSquare } from "@fortawesome/free-brands-svg-icons";\nimport { FontAwesomeIcon } from "@fortawesome/react-fontawesome";\nimport { Skeleton, Title, Tooltip, useMantineTheme } from "@mantine/core";\nimport { useMediaQuery } from "@mantine/hooks";\n\nimport { SimpleExternalLink } from "@shared/components";\n\nimport { WorkbenchContext } from "@pages/editor/providers";\n\nconst TitleDiv = styled.div`\n  display: flex;\n  gap: 8px;\n  font-size: var(--mantine-font-size-xl);\n  overflow-x: hidden;\n  /* shrink more than other texts in the header */\n  flex-shrink: 4;\n  position: relative;\n`;\n\nconst sourceUriToHistory = (sourceUri: string | undefined) => {\n  if (!sourceUri || !sourceUri.startsWith("https://github.com"))\n    return undefined;\n  return sourceUri.replace("blob", "commits");\n};\n\nconst EditorTitleNotObserving = () => {\n  const { workbench } = useContext(WorkbenchContext);\n  const { bundle } = workbench;\n  const { breakpoints } = useMantineTheme();\n  const isMobile = useMediaQuery(`(max-width: ${breakpoints.sm})`);\n\n  const gitHistoryLink = sourceUriToHistory(\n    workbench.remoteBundle?.displayProps.sourceUri\n  );\n\n  return (\n    <TitleDiv>\n      {bundle === null ? (\n        <Skeleton height={24} width={144} />\n      ) : (\n        <Tooltip\n          position="right-start"\n          withArrow\n          withinPortal\n          label={\n            <>\n              To change the name, edit the <code>id</code> key in the editor:\n              <br />\n              // KB note - we would like to detect this null coalescing operator and then use its presence to detect the *missing* operator on line 62\n              // ok: ts-null-coalescing\n              <code>id: {bundle?.rule?.id ?? "<add rule id here>"}</code>\n              // ok: ts-null-coalescing\n              <code>id: {bundle?.rule.id ?? "<add rule id here>"}</code>\n            </>\n          }\n        >\n          {isMobile ? (\n            <Title order={3} truncate color="white">\n              {/* using a template literal here to keep the editor from crashing if the rule id is wrapped in curly braces */}\n              // ruleid: ts-null-coalescing\n              {bundle.lastTitle.length <= 18\n                ? `${bundle.lastTitle}`\n                : `${bundle.lastTitle.slice(0, 13)}...`}\n            </Title>\n          ) : (\n            <Title order={3} truncate color="white">\n              {/* using a template literal here to keep the editor from crashing if the rule id is wrapped in curly braces */}\n              {bundle.lastTitle}\n            </Title>\n          )}\n        </Tooltip>\n      )}\n      {gitHistoryLink && (\n        <SimpleExternalLink\n          // align icon to text\n          style={{ marginTop: "6px" }}\n          href={gitHistoryLink}\n        >\n          <FontAwesomeIcon icon={faGithubSquare} />\n        </SimpleExternalLink>\n      )}\n    </TitleDiv>\n  );\n};\n\nexport const EditorTitle = observer(EditorTitleNotObserving);',
          language: "js",
        },
      ],
      ruleSupersededBy: [],
    },
    {
      issuesCount: 30,
      ruleId: 1697048,
      ruleShaSum:
        "7d64223fa249d9f7878111d9ce10a388c9b7650a3db324b987fce0c5bd7b58ac",
      ruleVisibility: RuleVisibility.TEAM_TIER,
      ruleMeta: {
        author: "semgrep",
        authorPhotoUrl: "https://github.com/semgrep.png",
        rule: {
          ruleId: "5rU3v0A",
          ruleVersionId: "1697048",
        },
      },
      ruleLastChangeAt: new Date(Date.parse("01 Nov 2023 14:49:18 GMT")),
      ruleLastChangeBy: "pangngan",
      ruleDefinition: {
        rules: [
          {
            id: "active-debug-code-printstacktrace",
            message:
              "Possible active debug code detected. Deploying an application with debug code can create unintended entry points or expose sensitive information.",
            severity: "WARNING",
            metadata: {
              likelihood: "LOW",
              impact: "LOW",
              confidence: "MEDIUM",
              category: "security",
              subcategory: ["audit"],
              cwe: ["CWE-489: Active Debug Code"],
              "functional-categories": [
                "debug::search::active-debug-code::java.lang",
              ],
              owasp: [
                "A10:2004 - Insecure Configuration Management",
                "A06:2017 - Security Misconfiguration",
                "A05:2021 - Security Misconfiguration",
              ],
              references: [
                "https://cwe.mitre.org/data/definitions/489.html",
                "https://www.acunetix.com/vulnerabilities/web/stack-trace-disclosure-java/",
                "https://owasp.org/www-project-web-security-testing-guide/v41/4-Web_Application_Security_Testing/08-Testing_for_Error_Handling/02-Testing_for_Stack_Traces",
                "https://www.securecodewarrior.com/blog/coders-conquer-security-share-learn-series-information-exposure",
              ],
              technology: ["java"],
              license: "Copyright 2023 Semgrep, Inc.",
              vulnerability_class: ["Active Debug Code"],
            },
            languages: ["java"],
            "pattern-either": [
              {
                pattern: "printStackTrace()",
              },
              {
                pattern: "$EXCEPTION.printStackTrace()",
              },
              {
                pattern: "$UTIL.printStackTrace(...)",
              },
            ],
          },
        ],
      },
      rulePath:
        "java.lang.security.audit.active-debug-code-printstacktrace.active-debug-code-printstacktrace",
      ruleSourceUri:
        "https://github.com/semgrep/semgrep-rules-proprietary/blob/develop/paid/java/lang/security/audit/active-debug-code-printstacktrace.yaml",
      ruleTestCases: [
        {
          target:
            "public class ActiveDebugCode{\n\n\n    public void bad(){\n        Exception e = new Exception();\n        // ruleid: active-debug-code-printstacktrace\n        e.printStackTrace();\n\n        // ruleid: active-debug-code-printstacktrace\n        Thread.currentThread().printStackTrace();\n\n        // ruleid: active-debug-code-printstacktrace\n        printStackTrace();\n\n        // ruleid: active-debug-code-printstacktrace\n        new Throwable().printStackTrace();\n\n        // ruleid: active-debug-code-printstacktrace\n        org.apache.commons.lang3.exception.ExceptionUtils.printStackTrace(e);\n\n    }\n\n\n}\n",
          language: "java",
        },
      ],
      ruleSupersededBy: [],
    },
    {
      issuesCount: 24,
      ruleId: 8270,
      ruleShaSum:
        "64e2fae8178b4848dba217091e63da71c6167ca490b43279fb18211f29b494b0",
      ruleVisibility: RuleVisibility.PUBLIC,
      ruleMeta: {
        author: "semgrep",
        authorPhotoUrl: "https://github.com/semgrep.png",
        rule: {
          ruleId: "JDUyDg",
          ruleVersionId: "8270",
        },
      },
      ruleLastChangeAt: new Date(Date.parse("01 Nov 2023 14:48:34 GMT")),
      ruleLastChangeBy: "pangngan",
      ruleDefinition: {
        rules: [
          {
            id: "unescaped-template-extension",
            message:
              "Flask does not automatically escape Jinja templates unless they have .html, .htm, .xml, or .xhtml extensions. This could lead to XSS attacks. Use .html, .htm, .xml, or .xhtml for your template extensions. See https://flask.palletsprojects.com/en/1.1.x/templating/#jinja-setup for more information.",
            metadata: {
              cwe: [
                "CWE-79: Improper Neutralization of Input During Web Page Generation ('Cross-site Scripting')",
              ],
              owasp: [
                "A07:2017 - Cross-Site Scripting (XSS)",
                "A03:2021 - Injection",
              ],
              "source-rule-url": "https://pypi.org/project/flake8-flask/",
              references: [
                "https://flask.palletsprojects.com/en/1.1.x/templating/#jinja-setup",
                "https://semgrep.dev/blog/2020/bento-check-unescaped-template-extensions-in-flask/",
                "https://bento.dev/checks/flask/unescaped-file-extension/",
              ],
              category: "security",
              technology: ["flask"],
              "cwe2022-top25": true,
              "cwe2021-top25": true,
              subcategory: ["audit"],
              likelihood: "LOW",
              impact: "MEDIUM",
              confidence: "LOW",
              license: "Commons Clause License Condition v1.0[LGPL-2.1-only]",
              vulnerability_class: ["Cross-Site-Scripting (XSS)"],
            },
            patterns: [
              {
                "pattern-not": 'flask.render_template("=~/.+\\.html$/", ...)',
              },
              {
                "pattern-not": 'flask.render_template("=~/.+\\.xml$/", ...)',
              },
              {
                "pattern-not": 'flask.render_template("=~/.+\\.htm$/", ...)',
              },
              {
                "pattern-not": 'flask.render_template("=~/.+\\.xhtml$/", ...)',
              },
              {
                "pattern-not":
                  'flask.render_template($X + "=~/\\.html$/", ...)',
              },
              {
                "pattern-not": 'flask.render_template($X + "=~/\\.xml$/", ...)',
              },
              {
                "pattern-not": 'flask.render_template($X + "=~/\\.htm$/", ...)',
              },
              {
                "pattern-not":
                  'flask.render_template($X + "=~/\\.xhtml$/", ...)',
              },
              {
                "pattern-not":
                  'flask.render_template("=~/.+\\.html$/" % $X, ...)',
              },
              {
                "pattern-not":
                  'flask.render_template("=~/.+\\.xml$/" % $X, ...)',
              },
              {
                "pattern-not":
                  'flask.render_template("=~/.+\\.htm$/" % $X, ...)',
              },
              {
                "pattern-not":
                  'flask.render_template("=~/.+\\.xhtml$/" % $X, ...)',
              },
              {
                "pattern-not":
                  'flask.render_template("=~/.+\\.html$/".format(...), ...)',
              },
              {
                "pattern-not":
                  'flask.render_template("=~/.+\\.xml$/".format(...), ...)',
              },
              {
                "pattern-not":
                  'flask.render_template("=~/.+\\.htm$/".format(...), ...)',
              },
              {
                "pattern-not":
                  'flask.render_template("=~/.+\\.xhtml$/".format(...), ...)',
              },
              {
                "pattern-not": "flask.render_template($TEMPLATE)",
              },
              {
                "pattern-either": [
                  {
                    pattern: 'flask.render_template("...", ...)',
                  },
                  {
                    pattern: 'flask.render_template($X + "...", ...)',
                  },
                  {
                    pattern: 'flask.render_template("..." % $Y, ...)',
                  },
                  {
                    pattern: 'flask.render_template("...".format(...), ...)',
                  },
                ],
              },
            ],
            languages: ["python"],
            severity: "WARNING",
          },
        ],
      },
      rulePath:
        "python.flask.security.unescaped-template-extension.unescaped-template-extension",
      ruleSourceUri:
        "https://github.com/semgrep/semgrep-rules/blob/develop/python/flask/security/unescaped-template-extension.yaml",
      ruleTestCases: [
        {
          target:
            'from flask import Flask, render_template\napp = Flask(__name__)\n\n@app.route("/unsafe")\ndef unsafe():\n    # ruleid: unescaped-template-extension\n    return render_template("unsafe.txt", name=request.args.get("name"))\n\n@app.route("/really_unsafe")\ndef really_unsafe():\n    name = request.args.get("name")\n    age = request.args.get("age")\n    # ruleid: unescaped-template-extension\n    return render_template("unsafe.txt", name=name, age=age)\n\n@app.route("/no_extension")\ndef no_extension():\n    # ruleid: unescaped-template-extension\n    return render_template("will-crash-without-extension", name=request.args.get("name"))\n\n# Test a bunch at the same time\nevil = "<script>alert(\'blah\')</script>"\n\n@app.route("/one")\ndef one():\n    # ruleid: unescaped-template-extension\n    return render_template("unsafe.unsafe", name=evil)\n\n@app.route("/two")\ndef two():\n    # ruleid: unescaped-template-extension\n    return render_template("unsafe.email", name=evil)\n\n@app.route("/three")\ndef three():\n    # ruleid: unescaped-template-extension\n    return render_template("unsafe.jinja2", name=evil)\n\n@app.route("/four")\ndef four():\n    # ruleid: unescaped-template-extension\n    return render_template("unsafe.template", name=evil)\n\n@app.route("/five")\ndef five():\n    # ruleid: unescaped-template-extension\n    return render_template("unsafe.asdlfkjasdlkjf", name=evil)\n\n@app.route("/six")\ndef six():\n    # ruleid: unescaped-template-extension\n    return render_template("unsafe.html.j2", name=evil)\n\n@app.route("no_vars")\ndef no_vars():\n    # ok: unescaped-template-extension\n    return render_template("unsafe.txt")\n\n@app.route("/escaped_extensions")\ndef escaped_extensions():\n    # ok: unescaped-template-extension\n    return render_template("safe.html", name=request.args.get("name"))\n\n@app.route("/concat")\ndef concat():\n    # ruleid: unescaped-template-extension\n    msg.body = render_template(template + \'.txt\', **kwargs)\n    # ok: unescaped-template-extension\n    msg.html = render_template(template + \'.html\', **kwargs)\n    # ruleid: unescaped-template-extension\n    return render_template(\'%s.txt\' % style, **kwargs).replace(\'<table>\', table)\n\n@app.route("/format")\ndef format():\n    name = "world"\n    # ruleid: unescaped-template-extension\n    return render_template("{}.txt".format("hello"), name)\n\n@app.route("/format-ok")\ndef format():\n    name = "world"\n    # ok: unescaped-template-extension\n    return render_template("{}.html".format("hello"), name)\n\nfrom library import render_template\ndef not_flask():\n    from library import render_template\n    # ok: unescaped-template-extension\n    return render_template("hello.txt")\n\n@app.route("/what_if")\ndef what_if():\n    cond = request.args.get("cond")\n    if cond:\n        template = "unsafe.txt"\n    else:\n        template = "safe.html"\n    return render_template(template, cond=cond)\n\n# Real-world code\n@app.route("/opml")\ndef opml():\n    sort_key = flask.request.args.get("sort", "(unread > 0) DESC, snr")\n    if sort_key == "feed_title":\n        sort_key = "lower(feed_title)"\n    order = flask.request.args.get("order", "DESC")\n    with dbop.db() as db:\n        rows = dbop.opml(db)\n        return (\n            # ruleid: unescaped-template-extension\n            flask.render_template("opml.opml", atom_content=atom_content, rows=rows),\n            200,\n            {"Content-Type": "text/plain"},\n        )\n',
          language: "python",
        },
      ],
      ruleSupersededBy: [],
    },
    {
      issuesCount: 20,
      ruleId: 8344,
      ruleShaSum:
        "11000295c0071248de3db5d375e8a0c9906d768eccb5ce1f25b28297189c0b67",
      ruleVisibility: RuleVisibility.PUBLIC,
      ruleMeta: {
        author: "semgrep",
        authorPhotoUrl: "https://github.com/semgrep.png",
        rule: {
          ruleId: "2ZUb3Z",
          ruleVersionId: "8344",
        },
      },
      ruleLastChangeAt: new Date(Date.parse("01 Nov 2023 14:48:37 GMT")),
      ruleLastChangeBy: "pangngan",
      ruleDefinition: {
        rules: [
          {
            id: "useless-eqeq",
            patterns: [
              {
                "pattern-not-inside": "def __eq__(...):\n    ...\n",
              },
              {
                "pattern-not-inside": "def __cmp__(...):\n    ...\n",
              },
              {
                "pattern-not-inside": "assert(...)",
              },
              {
                "pattern-not-inside": "assert ..., ...",
              },
              {
                "pattern-not-inside": "assertTrue(...)",
              },
              {
                "pattern-not-inside": "assertFalse(...)",
              },
              {
                "pattern-either": [
                  {
                    pattern: "$X == $X",
                  },
                  {
                    pattern: "$X != $X",
                  },
                ],
              },
              {
                "pattern-not": "1 == 1",
              },
            ],
            message:
              "This expression is always True: `$X == $X` or `$X != $X`. If testing for floating point NaN, use `math.isnan($X)`, or `cmath.isnan($X)` if the number is complex.",
            languages: ["python"],
            severity: "INFO",
            metadata: {
              category: "correctness",
              technology: ["python"],
              license: "Commons Clause License Condition v1.0[LGPL-2.1-only]",
            },
          },
        ],
      },
      rulePath: "python.lang.correctness.useless-eqeq.useless-eqeq",
      ruleSourceUri:
        "https://github.com/semgrep/semgrep-rules/blob/develop/python/lang/correctness/useless-eqeq.yaml",
      ruleTestCases: [
        {
          target:
            '\n# ruleid:useless-eqeq\nx == x\n\ndef __eq__(self, other):\n    # ok:useless-eqeq\n    return self == self and self == other\n\ndef sure(ofcourse):\n    # ok:useless-eqeq\n    return 1 == 1\n\nclass A:\n    def __eq__(self, other):\n        # ok:useless-eqeq\n        return self == self and self == other\n\n\n# ok:useless-eqeq\nassert(x == x)\n# ok:useless-eqeq\nassert x == x\n# ok:useless-eqeq\nassert x == x, "of course"\n# ok:useless-eqeq\nassertTrue(x ==x)\n# ok:useless-eqeq\nassertFalse(x == x)\n\n# ruleid:useless-eqeq\nprint(x != x)\n',
          language: "python",
        },
      ],
      ruleSupersededBy: [],
    },
    {
      issuesCount: 20,
      ruleId: 1752808,
      ruleShaSum:
        "9c602e30a63d065caf3fa577017711b2d2dc0090c7e53193b75418cc6c4dd43f",
      ruleVisibility: RuleVisibility.TEAM_TIER,
      ruleMeta: {
        author: "semgrep",
        authorPhotoUrl: "https://github.com/semgrep.png",
        rule: {
          ruleId: "KxUOBg9",
          ruleVersionId: "1752808",
        },
      },
      ruleLastChangeAt: new Date(Date.parse("01 Nov 2023 14:49:18 GMT")),
      ruleLastChangeBy: "pangngan",
      ruleDefinition: {
        rules: [
          {
            id: "cookie-missing-samesite",
            message:
              "The application does not appear to verify inbound requests which can lead to a Cross-site request forgery (CSRF) vulnerability. If the application uses cookie-based authentication, an attacker can trick users into sending authenticated HTTP requests without their knowledge from any arbitrary domain they visit. To prevent this vulnerability start by identifying if the framework or library leveraged has built-in features or offers plugins for CSRF protection. CSRF tokens should be unique and securely random. The `Synchronizer Token` or `Double Submit Cookie` patterns with defense-in-depth mechanisms such as the `sameSite` cookie flag can help prevent CSRF. For more information, see: [Cross-site request forgery prevention](https://cheatsheetseries.owasp.org/cheatsheets/Cross-Site_Request_Forgery_Prevention_Cheat_Sheet.html)",
            severity: "WARNING",
            metadata: {
              likelihood: "LOW",
              impact: "LOW",
              confidence: "HIGH",
              category: "security",
              subcategory: ["audit"],
              asvs: {
                section: "V3: Session Management Verification Requirements",
                control_id: "3.4.3 Missing Cookie Attribute",
                control_url:
                  "https://github.com/OWASP/ASVS/blob/master/4.0/en/0x12-V3-Session-management.md#v34-cookie-based-session-management",
                version: "4",
              },
              cwe: ["CWE-352: Cross-Site Request Forgery (CSRF)"],
              "cwe2021-top25": true,
              "cwe2022-top25": true,
              "functional-categories": ["web::search::cookie-config::Servlet"],
              owasp: ["A01:2021 - Broken Access Control"],
              references: [
                "https://stackoverflow.com/questions/42717210/samesite-cookie-in-java-application",
              ],
              technology: ["java", "servlets"],
              license: "Copyright 2023 Semgrep, Inc.",
              vulnerability_class: ["Cross-Site Request Forgery (CSRF)"],
            },
            languages: ["java"],
            patterns: [
              {
                "pattern-not-inside":
                  '$RETURNTYPE $METHOD(..., HttpServletResponse $RESP, ...) {\n  ...\n  $RESP.setHeader("Set-Cookie", "=~/.*SameSite=.*/");\n  ...\n}\n',
              },
              {
                "pattern-either": [
                  {
                    pattern: "$RESP.addCookie(...);",
                  },
                  {
                    pattern: '$RESP.setHeader("Set-Cookie", ...);',
                  },
                ],
              },
              {
                "pattern-not": '$RESP.setHeader("Set-Cookie", null);',
              },
            ],
          },
        ],
      },
      rulePath:
        "java.servlets.security.audit.cookie-missing-samesite.cookie-missing-samesite",
      ruleSourceUri:
        "https://github.com/semgrep/semgrep-rules-proprietary/blob/develop/paid/java/servlets/security/audit/cookie-missing-samesite.yaml",
      ruleTestCases: [
        {
          target:
            '@Controller\npublic class CookieController {\n\n    @RequestMapping(value = "/cookie1", method = "GET")\n    public void setCookie(@RequestParam String value, HttpServletResponse response) {\n        // ok:cookie-missing-samesite\n        response.setHeader("Set-Cookie", "key=value; HttpOnly; SameSite=strict");\n    }\n\n    @RequestMapping(value = "/cookie2", method = "GET")\n    public void setSecureCookie(@RequestParam String value, HttpServletResponse response) {\n        // ruleid:cookie-missing-samesite\n        response.setHeader("Set-Cookie", "key=value; HttpOnly;");\n    }\n\n    @RequestMapping(value = "/cookie3", method = "GET")\n    public void setSecureHttponlyCookie(@RequestParam String value, HttpServletResponse response) {\n        Cookie cookie = new Cookie("cookie", value);\n        cookie.setSecure(true);\n        cookie.setHttpOnly(true);\n        // ruleid:cookie-missing-samesite\n        response.addCookie(cookie);\n    }\n\n    @RequestMapping(value = "/cookie4", method = "GET")\n    public void setEverything(@RequestParam String value, HttpServletResponse response) {\n        // ok:cookie-missing-samesite\n        response.setHeader("Set-Cookie", "key=value; HttpOnly; Secure; SameSite=strict");\n        response.addCookie(cookie);\n    }\n}\n',
          language: "java",
        },
      ],
      ruleSupersededBy: [],
    },
    {
      issuesCount: 18,
      ruleId: 8551,
      ruleShaSum:
        "83edeb71d90c6d1a3c29196356f2670f1dcf87f00c1af3149d21c658c5e78e7a",
      ruleVisibility: RuleVisibility.PUBLIC,
      ruleMeta: {
        author: "semgrep",
        authorPhotoUrl: "https://github.com/semgrep.png",
        rule: {
          ruleId: "yyUneO",
          ruleVersionId: "8551",
        },
      },
      ruleLastChangeAt: new Date(Date.parse("01 Nov 2023 14:48:19 GMT")),
      ruleLastChangeBy: "pangngan",
      ruleDefinition: {
        rules: [
          {
            id: "unsafe-reflection",
            patterns: [
              {
                pattern: "Class.forName($CLASS,...)\n",
              },
              {
                "pattern-not": 'Class.forName("...",...)\n',
              },
              {
                "pattern-not-inside": '$CLASS = "...";\n...\n',
              },
            ],
            message:
              "If an attacker can supply values that the application then uses to determine which class to instantiate or which method to invoke, the potential exists for the attacker to create control flow paths through the application that were not intended by the application developers. This attack vector may allow the attacker to bypass authentication or access control checks or otherwise cause the application to behave in an unexpected manner.",
            metadata: {
              cwe: [
                "CWE-470: Use of Externally-Controlled Input to Select Classes or Code ('Unsafe Reflection')",
              ],
              owasp: ["A03:2021 - Injection"],
              "source-rule-url":
                "https://owasp.org/www-community/vulnerabilities/Unsafe_use_of_Reflection",
              category: "security",
              technology: ["java"],
              references: ["https://owasp.org/Top10/A03_2021-Injection"],
              subcategory: ["audit"],
              likelihood: "LOW",
              impact: "LOW",
              confidence: "LOW",
              license: "Commons Clause License Condition v1.0[LGPL-2.1-only]",
              vulnerability_class: ["Improper Authorization"],
            },
            severity: "WARNING",
            languages: ["java"],
          },
        ],
      },
      rulePath: "java.lang.security.audit.unsafe-reflection.unsafe-reflection",
      ruleSourceUri:
        "https://github.com/semgrep/semgrep-rules/blob/develop/java/lang/security/audit/unsafe-reflection.yaml",
      ruleTestCases: [
        {
          target:
            'package org.learn;\n\nimport java.util.ArrayList;\n\npublic class DemoForClassName {\n\n    private static void demoCreateThread(String userInput) throws ClassNotFoundException,\n            IllegalAccessException, InstantiationException, InterruptedException {\n        // ruleid: unsafe-reflection\n        Class<?> loadClass = Class.forName(userInput + "MyThread");\n\n        Thread thread = (Thread) loadClass.newInstance();\n        thread.start();\n        thread.join();\n    }\n\n    private static void demoOk() throws ClassNotFoundException,\n            IllegalAccessException, InstantiationException, InterruptedException {\n        // ok: unsafe-reflection\n        Class<?> loadClass = Class.forName("org.learn.MyThread");\n\n        Thread thread = (Thread) loadClass.newInstance();\n        thread.start();\n        thread.join();\n    }\n\n}\n',
          language: "java",
        },
      ],
      ruleSupersededBy: [],
    },
  ],
};
